export { default } from './DependsOnPills';
